import React, { useState, useEffect, useRef } from 'react';

/*
 * Global yükleme göstergesi.
 * - Herhangi bir API isteği 300ms'den uzun sürerse ekranın en üstünde
 *   akan bir ilerleme çubuğu gösterir (kısa isteklerde titreşim olmasın diye gecikmeli).
 * - İstek 4 saniyeyi aşarsa (Render ücretsiz sunucusu uykudan uyanıyordur)
 *   sağ altta "Sunucu uyandırılıyor" bilgi kartı çıkar — kullanıcı donma sanmasın.
 */
function YuklemeGostergesi() {
  const [cubukGoster, setCubukGoster] = useState(false);
  const [uyandirmaGoster, setUyandirmaGoster] = useState(false);
  const cubukZamanlayici = useRef(null);
  const uyandirmaZamanlayici = useRef(null);

  useEffect(() => {
    const dinleyici = (e) => {
      const aktif = e.detail?.aktif;
      if (aktif) {
        if (!cubukZamanlayici.current) {
          cubukZamanlayici.current = setTimeout(() => setCubukGoster(true), 300);
        }
        if (!uyandirmaZamanlayici.current) {
          uyandirmaZamanlayici.current = setTimeout(() => setUyandirmaGoster(true), 4000);
        }
      } else {
        clearTimeout(cubukZamanlayici.current);
        clearTimeout(uyandirmaZamanlayici.current);
        cubukZamanlayici.current = null;
        uyandirmaZamanlayici.current = null;
        setCubukGoster(false);
        setUyandirmaGoster(false);
      }
    };
    window.addEventListener('api-yukleme', dinleyici);
    return () => {
      window.removeEventListener('api-yukleme', dinleyici);
      clearTimeout(cubukZamanlayici.current);
      clearTimeout(uyandirmaZamanlayici.current);
    };
  }, []);

  return (
    <>
      {cubukGoster && (
        <div className="global-yukleme-cubugu" role="progressbar" aria-label="Yükleniyor">
          <div className="global-yukleme-cubugu-ic" />
        </div>
      )}
      {uyandirmaGoster && (
        <div className="sunucu-uyandirma-karti">
          <div className="spinner-border spinner-border-sm flex-shrink-0" role="status" aria-hidden="true" />
          <div>
            <strong>Sunucu uyandırılıyor…</strong>
            <div className="sunucu-uyandirma-detay">
              Sistem bir süredir kullanılmadığı için yeniden başlatılıyor. Bu ilk açılış 30-60 saniye
              sürebilir, sonrasında her şey hızlı çalışır. Lütfen sayfayı kapatmayın.
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default YuklemeGostergesi;
